import React, { useEffect, useState } from 'react';
import { PieChart, Pie, ResponsiveContainer } from 'recharts';
import { getPercentageHelper } from 'src/helpers/getPercentageHelper';

export const SubscriptionPieChart = ({ data }) => {
  const [dataArray, setData] = useState([]);

  useEffect(() => {
    const product = {
      coagent: Number(data?.coagent?.by_source) || 0,
      cobi: Number(data?.cobi?.by_source) || 0,
      cocustomer: Number(data?.cocustomer?.by_source) || 0,
      playground: Number(data?.playground?.by_source) || 0,
    };
    const productSum = product.coagent + product.cobi + product.cocustomer + product.playground;

    const coAgentPercent = getPercentageHelper(product.coagent, productSum);
    const coBiPercent = getPercentageHelper(product.cobi, productSum);
    const coCustomerPercent = getPercentageHelper(
      product.cocustomer + product.playground,
      productSum,
    );

    setData([
      {
        name: 'AI Agent',
        value: product.cocustomer + product.playground,
        percent: coCustomerPercent || 0,
        fill: '#A498FF',
      },
      {
        name: 'AI Assistant',
        value: product.coagent,
        percent: coAgentPercent || 0,
        fill: '#75F3FB',
      },
      {
        name: 'Business Intelligence',
        value: product.cobi,
        percent: coBiPercent || 0,
        fill: '#DFF800',
      },
    ]);
  }, [data]);

  return (
    <>
      <div className="min-w-36">
        <ResponsiveContainer
          width="100%"
          height="100%"
          style={{
            position: 'relative',
            textAlign: 'center',
          }}
        >
          <PieChart width={'100%'} height={'90%'} style={{ aspectRatio: 1, margin: 'auto' }}>
            <Pie
              startAngle={90}
              endAngle={-270}
              data={dataArray}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={'100%'}
              fill="#8884d8"
              dataKey="value"
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="w-full flex flex-col justify-center gap-3.5">
        <p className="text-ebony font-bold text-sm text-nowrap font-jamjuree">Usage by product</p>
        <div className="flex flex-col gap-2.5">
          {dataArray.map((item) => {
            return (
              <div key={item.name} className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: item.fill }} />
                <div className="flex items-center gap-1">
                  <p className="font-medium text-ebony text-sm font-jamjuree">{item.name}:</p>
                  <p className="font-bold text-ebony text-sm font-jamjuree">
                    {item.value} ({item.percent.toFixed()}%)
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
